export const PlayerService = {
    showLoginOrRegistration(registrationSettings = {}) {
        if (AsgFW.isRegistered()) {
            AsgFW.showLogin();
        } else {
            AsgFW.showRegistration(registrationSettings);
        }
    },

    async fetchPersonalSegments(playerId, casinoId) {
        let playerSegments = null;
        await SolarGatewayAPI.get(
            '/api/v1/segmentations/player',
            {
                playerId,
                casinoId,
            },
            (response) => {
                playerSegments = response?.data?.playerSegments || null;
            },
            (e) => {
                Tools.error('GET player segments request failed', e);
            },
        );
        return playerSegments;
    },
};
